"use client";

import React, { useEffect } from "react";
import { Phone } from "lucide-react";

import CustomLink from "../other/CustomLink";
import { cn } from "@/lib/utils";
import { navTriggerStyle } from "../other/constants";
import { gtLayer } from "@/hooks/use-gt-layer";

export interface ITelephoneProps {
  contactNumber: string;
  showNumber?: boolean;
  size?: number;
  strokeWidth?: number;
  gtmEvent?: boolean;
}
const TelNumberNavbar = ({
  contactNumber,
  showNumber = true,
  size = 16,
  strokeWidth = 2,
  gtmEvent = false,
}: ITelephoneProps) => {
  useEffect(() => {
    if (window.CallTrk) {
      window.CallTrk.swap();
    }
  }, []);

  const { mainCtaMenuDataLayer } = gtLayer();

  return (
    <CustomLink
      href={`tel:${contactNumber}`}
      className={cn(
        navTriggerStyle,
        "after:-bottom-[3px] pb-[1px] font-saira text-14 font-[500] tracking-[-0.1px] leading-[1.7] flex flex-row items-center gap-1"
      )}
      {...(gtmEvent && {
        onPointerDown: () => {
          mainCtaMenuDataLayer("phone_number");
        },
      })}
    >
      <Phone size={size} aria-label="phone" strokeWidth={strokeWidth} />
      {showNumber && <span className="text-royal-blue inline">{contactNumber}</span>}
    </CustomLink>
  );
};

export default TelNumberNavbar;
